import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { endpoints } from "@/lib/api";

const KEY = ["Appearances", "Minutes Played", "Goals", "Assists", "Yellowcards", "Redcards", "Shots Total", "Shots On Target", "Passes", "Key Passes", "Tackles", "Interceptions", "Saves", "Cleansheets", "Rating"];

export default function FootballPlayer() {
  const { id } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { setP(null); endpoints.footballPlayer(id).then((r) => setP(r.data)).catch(() => setErr(true)); }, [id]);
  if (err) return <div className="text-center text-slate-300 py-24" data-testid="player-error">Player details are unavailable.</div>;
  if (!p) return <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin text-[#E11D2A]" /></div>;
  const age = p.dob ? Math.floor((Date.now() - new Date(p.dob)) / 3.15576e10) : null;
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8" data-testid="player-page">
      <button onClick={() => nav(-1)} className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white mb-5"><ArrowLeft className="w-4 h-4" /> Back</button>
      <div className="flex items-center gap-5 mb-8">
        {p.photoUrl ? <img src={p.photoUrl} alt={p.name} className="w-24 h-24 rounded-2xl object-cover bg-[#121620]" /> : <div className="w-24 h-24 rounded-2xl bg-[#121620]" />}
        <div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white">{p.name}</h1>
          <div className="text-sm text-slate-300 mt-1 flex flex-wrap gap-x-4 gap-y-1">
            {p.position && <span>{p.detailedPosition || p.position}</span>}
            {p.nationality && <span className="inline-flex items-center gap-1">{p.nationalityFlag && <img src={p.nationalityFlag} alt="" className="w-4 h-3 object-cover" />}{p.nationality}</span>}
            {age && <span>{age} yrs</span>}{p.height && <span>{p.height} cm</span>}{p.weight && <span>{p.weight} kg</span>}
          </div>
          <div className="flex flex-wrap gap-2 mt-3">
            {p.teams.map((t) => <Link key={t.id} to={`/football/team/${t.id}`} className="inline-flex items-center gap-1.5 text-xs bg-[#121620] border border-[#273042] rounded-full px-3 py-1 text-slate-200 hover:text-white">
              {t.logoUrl && <img src={t.logoUrl} alt="" className="w-4 h-4 object-contain" />}{t.name}{t.number ? ` #${t.number}` : ""}</Link>)}
          </div>
        </div>
      </div>
      <h2 className="text-white font-bold mb-3">Season statistics</h2>
      {p.seasons.length === 0 ? <p className="text-slate-400">No statistics available.</p> : (
        <div className="space-y-4" data-testid="player-stats">
          {p.seasons.map((s) => {
            const keys = [...KEY.filter((k) => s.stats[k] != null), ...Object.keys(s.stats).filter((k) => !KEY.includes(k))];
            return (
              <div key={`${s.season}-${s.league}`} className="rounded-xl border border-[#273042] bg-[#121620] p-4">
                <div className="text-white font-semibold mb-3">{s.league} · {s.season}</div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {keys.slice(0, 16).map((k) => <div key={k}><div className="text-xl font-extrabold text-white">{typeof s.stats[k] === "number" ? Math.round(s.stats[k] * 100) / 100 : String(s.stats[k])}</div><div className="text-[11px] text-slate-400">{k}</div></div>)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
